import { InteractionType } from '@azure/msal-browser';
import { MsalInterceptorConfiguration } from '@azure/msal-angular';

import { environment } from 'src/environments/environment';
import { getDomainHint } from './get-domain-hint';

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, string[] | null>();

  protectedResourceMap.set(`${environment.apiUrl}/api/*`, [
    environment.auth.scope,
  ]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
    authRequest: {
      extraQueryParameters: {
        domain_hint: getDomainHint(),
      },
    },
  };
}
